import React from 'react';
import fr from 'facet-rest';
import HighPriorityActionCard from 'Views/Dashboard/HighPriorityActionCard';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';

const EstatePlanningCardPicker = (props) => {
  const { clientDashboardResource } = useDashboardContext();

  return clientDashboardResource.withRelationship(
    fr.relationships.estatePlanningRecommendation.name,
    (rel) => <HighPriorityActionCard relationship={rel} title={rel.meta('title')} subtitle={rel.meta('description')} data-test="estate-planning-entry-point" {...props} />,
    () => null,
  );
};

export default EstatePlanningCardPicker;
